import { render, staticRenderFns } from "./Summary1.vue?vue&type=template&id=159f82e8&"
import script from "./Summary1.vue?vue&type=script&lang=ts&"
export * from "./Summary1.vue?vue&type=script&lang=ts&"
import style0 from "./Summary1.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports